/* unplugin-vue-components disabled */import { render } from "./AccessibilityStatementEditVue.vue?vue&type=template&id=41872255&scoped=true&ts=true"
import script from "./AccessibilityStatementEditVue.vue?vue&type=script&lang=ts"
export * from "./AccessibilityStatementEditVue.vue?vue&type=script&lang=ts"

import "./AccessibilityStatementEditVue.vue?vue&type=style&index=0&id=41872255&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41872255"]])

export default __exports__